var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupShareIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.408 7.70083V12.6175C14.408 12.7793 14.2795 12.8763 14.1509 12.8763H5.79527C5.63458 12.8763 5.53817 12.7469 5.53817 12.6175V7.70083C5.53817 6.89216 6.18091 6.24523 6.98434 6.24523H8.78402L8.88043 5.46891C7.85205 5.0484 7.14503 4.01331 7.14503 2.84883C7.14503 1.2315 8.49479 -0.0623687 10.1338 0.00232464C11.5157 0.0670179 12.6726 1.19915 12.8012 2.59006C12.9297 3.88392 12.1584 5.01606 11.0658 5.46891L11.1622 6.24523H12.9619C13.7653 6.24523 14.408 6.89216 14.408 7.70083ZM18.8431 6.25251H17.4612L17.3969 5.63793C18.2325 5.28211 18.8109 4.40876 18.7145 3.40601C18.6181 2.33857 17.7504 1.49756 16.6899 1.43287C15.4365 1.36817 14.4081 2.37092 14.4081 3.60009C14.4081 4.5058 14.9545 5.28211 15.7579 5.60558L15.6936 6.22017H14.8259C15.1794 6.60833 15.4365 7.12587 15.4365 7.67577V12.0426H19.8072C19.9036 12.0426 20 11.9455 20 11.8485V7.31995C19.9679 6.73771 19.4858 6.25251 18.8431 6.25251ZM5.52759 3.40601C5.624 4.40875 5.04553 5.28211 4.20997 5.63793L4.30638 6.25251H5.17408C4.78843 6.60833 4.56348 7.12587 4.56348 7.70811V12.0749H0.192823C0.0964114 12.0749 0 11.9779 0 11.8808V7.3523C0 6.70537 0.514194 6.22017 1.1248 6.22017H2.5067L2.57097 5.60558C1.76754 5.28211 1.22121 4.5058 1.22121 3.60009C1.22121 2.37092 2.2496 1.36817 3.50295 1.43287C4.56348 1.49756 5.43118 2.33857 5.52759 3.40601Z",
    fill: "#0A68FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupShareIcons);
export default ForwardRef;